const TIERS = [
  {
    tier: 'Free',
    price: '$0',
    period: 'forever',
    credits: '10 MCU',
    features: ['10 free credits', 'Basic tasks (1 MCU)', 'Open-source CLI', 'Community support'],
    cta: 'Get Started',
    featured: false,
  },
  {
    tier: 'Starter',
    price: '$29',
    period: '/month',
    credits: '200 MCU',
    features: ['200 credits/month', 'All task types', 'Priority queue', 'Email support'],
    cta: 'Subscribe',
    featured: false,
  },
  {
    tier: 'Pro',
    price: '$99',
    period: '/month',
    credits: '1,000 MCU',
    features: ['1,000 credits/month', 'Self-healing pipeline', 'Webhook integrations', 'Audit trail', 'Dedicated support'],
    cta: 'Subscribe',
    featured: true,
  },
  {
    tier: 'Agency',
    price: '$199',
    period: '/month',
    credits: '5,000 MCU',
    features: ['5,000 credits/month', 'Multi-tenant agents', 'Custom workflows', 'SLA guarantee', 'Priority support'],
    cta: 'Subscribe',
    featured: false,
  },
]

export function PricingSection() {
  return (
    <section className="section" id="pricing">
      <div className="container">
        <h2 className="section-title">Simple, Transparent Pricing</h2>
        <p className="section-subtitle">
          Pay for results, not promises. Only charged after successful delivery.
        </p>
        <div className="pricing-grid">
          {TIERS.map((t) => (
            <div key={t.tier} className={`glass price-card ${t.featured ? 'featured' : ''}`}>
              {t.featured && <span className="popular-badge">Most Popular</span>}
              <div className="price-tier">{t.tier}</div>
              <div className="price-amount">{t.price}</div>
              <div className="price-period">{t.period} — {t.credits}</div>
              <ul className="price-features">
                {t.features.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
              <a
                href="https://raas.agencyos.network"
                className={`price-cta ${t.featured ? 'price-cta-primary' : 'price-cta-default'}`}
              >
                {t.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
